import * as React from 'react';
import { DraggableProps, DraggableCore } from './Draggable';
import { DroppableProps, DroppableCore } from './Droppable';
import { IsSetDragImageSupported } from '../utils/constants';

export interface DragAndDroppableProps extends DraggableProps, DroppableProps {}

// TODO: Bug 14032: Consider a framework-independent design of owa-dnd
export default class DragAndDroppable extends React.Component<DragAndDroppableProps, {}> {
    private dragCore: DraggableCore;
    private dropCore: DroppableCore;

    constructor(props: DragAndDroppableProps) {
        super(props);
        this.dragCore = new DraggableCore(props);
        this.dropCore = new DroppableCore(props);
    }

    render() {
        return IsSetDragImageSupported ? (
            <div
                draggable={this.props.isDraggable ? this.props.isDraggable() : true}
                className={this.props.classNames}
                ref={this.dragCore.refCallback}
                onDragStart={this.dragCore.onDragStart}
                onDragEnd={this.dragCore.onDragEnd}
                onDrop={this.dropCore.onDrop}
                onDragOver={this.dropCore.onDragOver}
                onDragEnter={this.dropCore.onDragEnter}
                onDragLeave={this.dropCore.onDragLeave}>
                {this.props.children}
            </div>
        ) : (
            <div
                className={this.props.classNames}
                ref={this.dragCore.refCallback}
                onDragEnd={this.dragCore.onDragEnd}
                onDrop={this.dropCore.onDrop}
                onDragOver={this.dropCore.onDragOver}
                onDragEnter={this.dropCore.onDragEnter}
                onDragLeave={this.dropCore.onDragLeave}>
                {this.props.children}
            </div>
        );
    }

    componentWillUnmount() {
        this.dragCore.onUnmount();
    }

    getDiv() {
        return this.dragCore.getDiv();
    }
}
